import type * as Types from '../../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SkillRecommendationFieldsFragment = { __typename?: 'SkillRecommendation', id: string, position: number, measuredLevel?: Types.ProficiencyLevel | null, classroomId: string, student: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }, guideLevel: { __typename?: 'GuideLevel', id: string, name: string, code?: string | null }, reasons: Array<{ __typename?: 'SkillRecommendationReason', code: Types.SkillRecommendationReasonCode, sourceLevel: Types.ProficiencyLevel, sourceSkillId: string, sourceSkill?: { __typename?: 'GuideLevel', id: string, name: string } | null }>, generation: { __typename?: 'SkillRecommendationGeneration', id: string, insertedAt: any, diagnostics: Array<{ __typename?: 'Diagnostic', id: string, name: string }> } };

export type SkillRecommendationsAsEducatorQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.SkillRecommendationFilterInput>;
  sort?: Types.InputMaybe<Array<Types.InputMaybe<Types.SkillRecommendationSortInput>> | Types.InputMaybe<Types.SkillRecommendationSortInput>>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SkillRecommendationsAsEducatorQuery = { __typename?: 'RootQueryType', skillRecommendationsAsEducator?: { __typename?: 'KeysetPageOfSkillRecommendation', count?: number | null, endKeyset?: string | null, results?: Array<{ __typename?: 'SkillRecommendation', id: string, position: number, measuredLevel?: Types.ProficiencyLevel | null, classroomId: string, student: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }, guideLevel: { __typename?: 'GuideLevel', id: string, name: string, code?: string | null }, reasons: Array<{ __typename?: 'SkillRecommendationReason', code: Types.SkillRecommendationReasonCode, sourceLevel: Types.ProficiencyLevel, sourceSkillId: string, sourceSkill?: { __typename?: 'GuideLevel', id: string, name: string } | null }>, generation: { __typename?: 'SkillRecommendationGeneration', id: string, insertedAt: any, diagnostics: Array<{ __typename?: 'Diagnostic', id: string, name: string }> } }> | null } | null };

export type SkillRecommendationsCountQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.SkillRecommendationFilterInput>;
}>;


export type SkillRecommendationsCountQuery = { __typename?: 'RootQueryType', skillRecommendationsAsEducator?: { __typename?: 'KeysetPageOfSkillRecommendation', count?: number | null } | null };

export type GenerateSkillRecommendationsMutationVariables = Types.Exact<{
  input: Types.GenerateSkillRecommendationsInput;
}>;


export type GenerateSkillRecommendationsMutation = { __typename?: 'RootMutationType', generateSkillRecommendations: Array<{ __typename?: 'SkillRecommendationGeneration', id: string }> };

export const SkillRecommendationFieldsFragmentDoc = gql`
    fragment SkillRecommendationFields on SkillRecommendation {
  id
  position
  measuredLevel
  classroomId
  student {
    id
    firstName
    lastName
  }
  guideLevel {
    id
    name
    code
  }
  reasons {
    code
    sourceLevel
    sourceSkillId
    sourceSkill {
      id
      name
    }
  }
  generation {
    id
    insertedAt
    diagnostics {
      id
      name
    }
  }
}
    `;
export const SkillRecommendationsAsEducatorDocument = gql`
    query SkillRecommendationsAsEducator($filter: SkillRecommendationFilterInput, $sort: [SkillRecommendationSortInput], $first: Int, $after: String) {
  skillRecommendationsAsEducator(
    filter: $filter
    sort: $sort
    first: $first
    after: $after
  ) {
    count
    endKeyset
    results {
      ...SkillRecommendationFields
    }
  }
}
    ${SkillRecommendationFieldsFragmentDoc}`;

/**
 * __useSkillRecommendationsAsEducatorQuery__
 *
 * To run a query within a React component, call `useSkillRecommendationsAsEducatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillRecommendationsAsEducatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillRecommendationsAsEducatorQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSkillRecommendationsAsEducatorQuery(baseOptions?: Apollo.QueryHookOptions<SkillRecommendationsAsEducatorQuery, SkillRecommendationsAsEducatorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillRecommendationsAsEducatorQuery, SkillRecommendationsAsEducatorQueryVariables>(SkillRecommendationsAsEducatorDocument, options);
      }
export function useSkillRecommendationsAsEducatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillRecommendationsAsEducatorQuery, SkillRecommendationsAsEducatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillRecommendationsAsEducatorQuery, SkillRecommendationsAsEducatorQueryVariables>(SkillRecommendationsAsEducatorDocument, options);
        }
// @ts-ignore
export function useSkillRecommendationsAsEducatorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SkillRecommendationsAsEducatorQuery, SkillRecommendationsAsEducatorQueryVariables>): Apollo.UseSuspenseQueryResult<SkillRecommendationsAsEducatorQuery, SkillRecommendationsAsEducatorQueryVariables>;
export function useSkillRecommendationsAsEducatorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SkillRecommendationsAsEducatorQuery, SkillRecommendationsAsEducatorQueryVariables>): Apollo.UseSuspenseQueryResult<SkillRecommendationsAsEducatorQuery | undefined, SkillRecommendationsAsEducatorQueryVariables>;
export function useSkillRecommendationsAsEducatorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SkillRecommendationsAsEducatorQuery, SkillRecommendationsAsEducatorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SkillRecommendationsAsEducatorQuery, SkillRecommendationsAsEducatorQueryVariables>(SkillRecommendationsAsEducatorDocument, options);
        }
export type SkillRecommendationsAsEducatorQueryHookResult = ReturnType<typeof useSkillRecommendationsAsEducatorQuery>;
export type SkillRecommendationsAsEducatorLazyQueryHookResult = ReturnType<typeof useSkillRecommendationsAsEducatorLazyQuery>;
export type SkillRecommendationsAsEducatorSuspenseQueryHookResult = ReturnType<typeof useSkillRecommendationsAsEducatorSuspenseQuery>;
export type SkillRecommendationsAsEducatorQueryResult = Apollo.QueryResult<SkillRecommendationsAsEducatorQuery, SkillRecommendationsAsEducatorQueryVariables>;
export const SkillRecommendationsCountDocument = gql`
    query SkillRecommendationsCount($filter: SkillRecommendationFilterInput) {
  skillRecommendationsAsEducator(filter: $filter, first: 1) {
    count
  }
}
    `;

/**
 * __useSkillRecommendationsCountQuery__
 *
 * To run a query within a React component, call `useSkillRecommendationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSkillRecommendationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSkillRecommendationsCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSkillRecommendationsCountQuery(baseOptions?: Apollo.QueryHookOptions<SkillRecommendationsCountQuery, SkillRecommendationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SkillRecommendationsCountQuery, SkillRecommendationsCountQueryVariables>(SkillRecommendationsCountDocument, options);
      }
export function useSkillRecommendationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SkillRecommendationsCountQuery, SkillRecommendationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SkillRecommendationsCountQuery, SkillRecommendationsCountQueryVariables>(SkillRecommendationsCountDocument, options);
        }
// @ts-ignore
export function useSkillRecommendationsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SkillRecommendationsCountQuery, SkillRecommendationsCountQueryVariables>): Apollo.UseSuspenseQueryResult<SkillRecommendationsCountQuery, SkillRecommendationsCountQueryVariables>;
export function useSkillRecommendationsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SkillRecommendationsCountQuery, SkillRecommendationsCountQueryVariables>): Apollo.UseSuspenseQueryResult<SkillRecommendationsCountQuery | undefined, SkillRecommendationsCountQueryVariables>;
export function useSkillRecommendationsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SkillRecommendationsCountQuery, SkillRecommendationsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SkillRecommendationsCountQuery, SkillRecommendationsCountQueryVariables>(SkillRecommendationsCountDocument, options);
        }
export type SkillRecommendationsCountQueryHookResult = ReturnType<typeof useSkillRecommendationsCountQuery>;
export type SkillRecommendationsCountLazyQueryHookResult = ReturnType<typeof useSkillRecommendationsCountLazyQuery>;
export type SkillRecommendationsCountSuspenseQueryHookResult = ReturnType<typeof useSkillRecommendationsCountSuspenseQuery>;
export type SkillRecommendationsCountQueryResult = Apollo.QueryResult<SkillRecommendationsCountQuery, SkillRecommendationsCountQueryVariables>;
export const GenerateSkillRecommendationsDocument = gql`
    mutation GenerateSkillRecommendations($input: GenerateSkillRecommendationsInput!) {
  generateSkillRecommendations(input: $input) {
    id
  }
}
    `;
export type GenerateSkillRecommendationsMutationFn = Apollo.MutationFunction<GenerateSkillRecommendationsMutation, GenerateSkillRecommendationsMutationVariables>;

/**
 * __useGenerateSkillRecommendationsMutation__
 *
 * To run a mutation, you first call `useGenerateSkillRecommendationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSkillRecommendationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSkillRecommendationsMutation, { data, loading, error }] = useGenerateSkillRecommendationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGenerateSkillRecommendationsMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSkillRecommendationsMutation, GenerateSkillRecommendationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSkillRecommendationsMutation, GenerateSkillRecommendationsMutationVariables>(GenerateSkillRecommendationsDocument, options);
      }
export type GenerateSkillRecommendationsMutationHookResult = ReturnType<typeof useGenerateSkillRecommendationsMutation>;
export type GenerateSkillRecommendationsMutationResult = Apollo.MutationResult<GenerateSkillRecommendationsMutation>;
export type GenerateSkillRecommendationsMutationOptions = Apollo.BaseMutationOptions<GenerateSkillRecommendationsMutation, GenerateSkillRecommendationsMutationVariables>;